import { useEffect } from 'react'

import { Box, Button, Title } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

// nosemgrep do_not_use_panes
import PanesPadForm from 'modules/core/components/PanesPadForm'
import SelectField from 'modules/core/components/SelectField'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateEmployeeRelatorioUnicoField } from 'modules/trainings/hooks/EmployeeRelatorioUnicoFields/useCreateEmployeeRelatorioUnicoField'
import { useEmployeeRelatorioUnicoFields } from 'modules/trainings/hooks/EmployeeRelatorioUnicoFields/useEmployeeRelatorioUnicoFields'
import { useUpdateEmployeeRelatorioUnicoField } from 'modules/trainings/hooks/EmployeeRelatorioUnicoFields/useUpdateEmployeeRelatorioUnicoField'
import { useTrainingsSettings } from 'modules/trainings/hooks/Settings/useTrainingsSettings'

interface EmployeeRelatorioUnicoFieldFormValues {
  retirementRegimeApplied?: string
  readonly?: boolean
  employeeId: number
}

const EmployeeRetirementRegimeApplied = (props: EmployeeRelatorioUnicoFieldFormValues) => {
  const { employeeId, readonly } = props
  const retirementRegimeOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.social_security'), value: 1 },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.general_retirement_fund'),
      value: 2,
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.another_regime'), value: 8 },
  ]
  const {
    company: { id: companyId },
  } = useCurrentSession()

  const { settings } = useTrainingsSettings(companyId)
  const setting = settings?.at(0)
  const relatorioEnabled = !!setting?.relatorioEnabled

  const { loading, employeeRelatorioUnicoField } = useEmployeeRelatorioUnicoFields(
    Number(employeeId)
  )
  const { loading: creating, create } = useCreateEmployeeRelatorioUnicoField()
  const { loading: updating, update } = useUpdateEmployeeRelatorioUnicoField()

  const form = useForm<EmployeeRelatorioUnicoFieldFormValues>({
    defaultValues: {
      retirementRegimeApplied: employeeRelatorioUnicoField?.retirementRegimeApplied || '',
      employeeId: employeeId,
    },
    onSubmit: async (data) => {
      if (employeeRelatorioUnicoField) {
        const result = await update({
          ...data,
          id: employeeRelatorioUnicoField.id,
        })

        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.employee_relatorio_fields.retirement_regime_wrong'),
          })
        })

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('trainings.employee_relatorio_fields.retirement_regime_updated'),
          })

          const values = form.values
          form.resetForm({ values })
        }

        return handled
      } else {
        const result = await create({ ...data, employeeId: Number(employeeId) })

        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.employee_relatorio_fields.retirement_regime_wrong'),
          })
        })

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('trainings.employee_relatorio_fields.retirement_regime_updated'),
          })

          const values = form.values
          form.resetForm({ values })
        }

        return handled
      }
    },
  })

  useEffect(() => {
    form.resetForm({
      values: {
        retirementRegimeApplied: employeeRelatorioUnicoField?.retirementRegimeApplied || '',
        employeeId: employeeId,
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId, employeeRelatorioUnicoField])

  return (
    <>
      {relatorioEnabled && (
        <PanesPadForm direction="horizontal" boxed>
          <Title
            variant="500"
            illustration="user"
            title={i18n.t('trainings.annex_c_relatorio_unico.retirement_regime_applied')}
            description={i18n.t('trainings.annex_c_relatorio_unico.retirement_regime_description')}
          />
          <Box gap="s24">
            <SelectField
              label={i18n.t('trainings.annex_c_relatorio_unico.retirement_regime_applied')}
              none={i18n.t('common.select_one')}
              value={form.values.retirementRegimeApplied}
              options={retirementRegimeOptions}
              onChange={(value) =>
                form.setValues({ ...form.values, retirementRegimeApplied: value })
              }
              readonly={readonly}
            />
            {form.dirty && (
              <Box alignSelf="flexEnd">
                <Button onClick={() => form.handleSubmit()}>{i18n.t('common.submit')}</Button>
              </Box>
            )}
          </Box>
        </PanesPadForm>
      )}
    </>
  )
}

export default observer(EmployeeRetirementRegimeApplied)
